import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BehaviorSubject, Observable } from 'rxjs';
import { map } from 'rxjs/operators';


@Injectable({ providedIn: 'root' })
export class TimbrarService {

     constructor(private http: HttpClient) {
    
    }

    registrar(sale_id, ambiente, tipo) {
      // console.log("entramos en timbrar service")

      return this.http.post<any>('https://vertigofin.herokuapp.com/', { sale_id, ambiente, tipo })
        .pipe(map(confirmacion => {
       
            // console.log("entramos en respuesta de timbrar")
            // console.log(confirmacion)
            return confirmacion;
        }));
    }


}